import { IQuestionById } from '@redux/Studio/QueryCreation/constants/queryCreation.interface';

/**
 * Returns the subQuestion name, either from the label (instance label) OR the original sub-question description
 * @param query
 * @param subQueryUri
 * @returns subQuery label (if renamed) or original description
 */
export const getSubQuestionName = (query: IQuestionById, subQueryUri: string | null) => {
  if (subQueryUri === null) return '';

  return (
    query.definition?.[subQueryUri]?.label ||
    query?.subQueries?.[query.definition?.[subQueryUri]?.subQueryId || '']?.description ||
    ''
  );
};
